import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const ADD_LOYALITY_POINT = SERVER_URI + '/loyality-points';
const GET_LOYALITY_POINT = SERVER_URI + '/get-loyality-points';
const CHANGE_LOYALITY_STATUS = SERVER_URI + '/loyality-point-status/';
const UPDATE_LOYALITY_LIST = SERVER_URI + '/loyality-points/';



export default {
    addLoyalityPoint: async function (paylaod) {
        console.log("location payload", paylaod)
        return apiPost(ADD_LOYALITY_POINT, paylaod);
      },

      getLoyalityPoint: async function () {
        return apiPost(GET_LOYALITY_POINT);
      },
       

      changeLoyalityStatus: async function (id) {
        return apiGet(CHANGE_LOYALITY_STATUS + id);
    
      },
      updateLoyality: async function (id,paylaod) {
       // console.log("id.....", id,paylaod)
        return apiPut(UPDATE_LOYALITY_LIST + id,paylaod)
      }
};

